import _ from 'lodash';
import frequencies from './frequencies';

const MONITOR_FREQUENCIES = _.cloneDeep(frequencies);

MONITOR_FREQUENCIES.HALF_MONTH = 'half-month';
MONITOR_FREQUENCIES.INSTANT = 'instant';

export default MONITOR_FREQUENCIES;
